import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "@/styled-system/tokens";
import { Box as l } from "../../node_modules/@zillow/constellation-10/dist/components/box/box.esm.js";
import { Button as o$1 } from "../../node_modules/@zillow/constellation-10/dist/components/button/button.esm.js";
import { Combobox as o } from "../../node_modules/@zillow/constellation-10/dist/components/combobox/combobox.esm.js";
import { Form as d } from "../../node_modules/@zillow/constellation-10/dist/components/form/form.esm.js";
import { Input as F } from "../../node_modules/@zillow/constellation-10/dist/components/input/input.esm.js";
import React__default from "react";
function assertSearchType(value) {
  if (value === "installation") {
    return;
  }
  if (value !== "zip" && value !== "installations") {
    throw new Error(`Invalid search type: "${value}". Expected 'zip' or 'installations'.`);
  }
}
const normalizeSearchType = (value) => {
  if (value === "installation") {
    return "installations";
  }
  assertSearchType(value);
  return value;
};
const AgentSearch = ({
  placeholder,
  search = "zip",
  disabled
}) => {
  const normalizedSearch = normalizeSearchType(search);
  const zipRef = React__default.useRef("");
  const handleSelectChange = (item) => {
    if (normalizedSearch === "installations" && item) {
      const installation = INSTALLATIONS.find((inst) => inst[0] === item);
      if (installation) {
        zipRef.current = installation[1];
      }
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
    const url = "https://www.zillow.com/professionals/relocation--real-estate-agent-reviews/" + zipRef.current;
    form.action = url;
    form.submit();
  };
  const INSTALLATIONS = [["Fort Novosel", "36362"], ["Portsmouth Naval Shipyard", "03904"], ["Camp Pendleton", "92055"]];
  const INSTALLATIONS_NAMES = INSTALLATIONS.map((inst) => inst[0]);
  return /* @__PURE__ */ jsx(d, { onSubmit: handleSubmit, target: "_blank", children: /* @__PURE__ */ jsxs(_StyledBox, { children: [
    normalizedSearch === "installations" ? /* @__PURE__ */ jsx(o, { options: INSTALLATIONS_NAMES, placeholder, "aria-label": "installations", onChange: handleSelectChange, disabled: !!disabled }) : /* @__PURE__ */ jsx(F, { type: "text", "aria-label": "zipcode", name: "zipcode", placeholder, disabled: !!disabled, onChange: (event) => zipRef.current = event.target.value }),
    /* @__PURE__ */ jsx(_StyledButton, { type: "submit", tone: "brand", emphasis: "filled", disabled: !!disabled, $_css: token("spacing.md"), children: "Find an agent" })
  ] }) });
};
var _StyledBox = styled(l)({
  display: "flex",
  flexDirection: "column"
});
var _StyledButton = styled(o$1).withConfig({
  displayName: "AgentSearch___StyledButton",
  componentId: "sc-12eo5wr-0"
})((p) => ({
  width: "100%",
  marginTop: p.$_css
}));
export {
  AgentSearch as default
};
